import type { RouteRecordRaw } from 'vue-router'

// 主 Tab 壳（4 tab：home/content/profile/me）
export const tabHomeRoutes: RouteRecordRaw[] = [
  {
    path: '/tab-home',
    redirect: '/tab-home/home',
  },
  {
    path: '/tab-home/:tabPath',
    name: 'tab-home',
    component: () => import('@/pages/TabHome/index.vue'),
    meta: { backMode: 'exit' },
  },
]
